export default __webpack_public_path__ + "static/media/img-clients_2.11d978c9.png";